export default {
  root: {
    padding: '12px 16px',
    fontWeight: 'bold',
    borderRadius: '4px',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    boxShadow: 'none',
    '&$focusVisible': {
      boxShadow: 'none',
      'outline-style': 'auto',
    },
    '&$disabled': {
      opacity: 0.5,
    },
  },
  outlined: {
    padding: '12px 16px',
  },
  text: {
    padding: '12px 16px',
  },
  sizeSmall: {
    padding: '12px 16px',
  },
  sizeLarge: {
    padding: '12px 16px',
  },
  contained: {
    boxShadow: 'none',
  },
};
